var _circle, _line, _line2, _line3, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEmotionThoughtless(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 376,
    viewBox: "0 0 290 376",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 144.833,
    cy: 144.833,
    r: 144.833,
    fill: "url(#paint0_radial_1486_9753)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 65.7656,
    y1: 106.902,
    x2: 117.398,
    y2: 106.902,
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 172.195,
    y1: 106.902,
    x2: 223.828,
    y2: 106.902,
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 119.016,
    y1: 198.031,
    x2: 170.648,
    y2: 198.031,
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.4395 355.825H34.3887V350.905H86.4395V355.825ZM63.2388 375.122H57.3037V353.952H63.2388V375.122ZM79.8696 343.701H40.895V321.293H79.8696V343.701ZM46.8301 338.972H73.8711V326.149H46.8301V338.972ZM100.087 345.764H93.9932V320.976H100.087V345.764ZM98.3413 344.494C103.144 344.494 107.397 344.367 111.1 344.113C114.824 343.859 118.559 343.394 122.304 342.717L123.034 347.573C119.098 348.292 115.226 348.8 111.417 349.096C107.63 349.371 103.271 349.509 98.3413 349.509H93.9932V344.494H98.3413ZM138.046 351.699H132.016V318.247H138.046V351.699ZM133.603 328.942H116.496V324.34H133.603V328.942ZM133.603 338.94H116.496V334.338H133.603V338.94ZM138.046 374.423H100.88V354.111H138.046V374.423ZM106.784 369.536H132.079V358.935H106.784V369.536ZM198.793 355.825H146.742V350.905H198.793V355.825ZM175.592 375.122H169.657V353.952H175.592V375.122ZM192.223 343.701H153.249V321.293H192.223V343.701ZM159.184 338.972H186.225V326.149H159.184V338.972ZM221.549 326.848C221.549 330.529 220.915 333.968 219.645 337.163C218.375 340.358 216.566 343.14 214.218 345.51C211.869 347.88 209.066 349.678 205.807 350.905L202.57 346.113C205.469 345.055 207.965 343.553 210.06 341.606C212.176 339.659 213.795 337.417 214.916 334.877C216.037 332.338 216.598 329.662 216.598 326.848V321.23H221.549V326.848ZM222.565 327.387C222.565 329.842 223.126 332.222 224.247 334.528C225.368 336.813 226.966 338.834 229.04 340.59C231.113 342.325 233.546 343.658 236.339 344.589L233.07 349.287C229.939 348.186 227.209 346.547 224.882 344.367C222.554 342.188 220.766 339.649 219.518 336.75C218.291 333.83 217.677 330.709 217.677 327.387V321.23H222.565V327.387ZM247.67 352.556H241.671V318.247H247.67V352.556ZM255.954 337.607H245.988V332.561H255.954V337.607ZM229.293 353.92C233.187 353.92 236.551 354.344 239.386 355.19C242.222 356.015 244.39 357.211 245.893 358.776C247.416 360.342 248.178 362.236 248.178 364.458C248.178 366.679 247.416 368.583 245.893 370.17C244.39 371.757 242.232 372.963 239.418 373.789C236.604 374.635 233.229 375.058 229.293 375.058C225.379 375.058 221.983 374.635 219.105 373.789C216.249 372.963 214.049 371.757 212.504 370.17C210.98 368.583 210.219 366.679 210.219 364.458C210.219 362.236 210.98 360.342 212.504 358.776C214.049 357.211 216.249 356.015 219.105 355.19C221.983 354.344 225.379 353.92 229.293 353.92ZM229.293 358.713C226.606 358.713 224.279 358.935 222.311 359.379C220.343 359.824 218.841 360.49 217.804 361.379C216.789 362.246 216.281 363.273 216.281 364.458C216.281 365.685 216.789 366.743 217.804 367.631C218.841 368.499 220.333 369.155 222.279 369.599C224.226 370.043 226.564 370.276 229.293 370.297C232.065 370.276 234.414 370.043 236.339 369.599C238.286 369.155 239.767 368.499 240.783 367.631C241.798 366.743 242.306 365.685 242.306 364.458C242.306 363.23 241.788 362.194 240.751 361.347C239.735 360.48 238.254 359.824 236.308 359.379C234.361 358.935 232.023 358.713 229.293 358.713Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1486_9753",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144.833 144.833) rotate(90) scale(144.833)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F391FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8AAFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmotionThoughtless);
export default __webpack_public_path__ + "static/media/IconEmotionThoughtless.50b899431d8e1e74a0d0fd2d60860e06.svg";
export { ForwardRef as ReactComponent };